"use strict";

var _interopRequireWildcard = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportExpiredWarehouseExcel = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _index = require("@/utils/index");
var _string = require("@/utils/string");
var Excel = _interopRequireWildcard(require("exceljs"));
var _fileSaver = require("file-saver");
var fontBold = {
  font: {
    bold: true
  }
};
var border = {
  top: {
    style: "thin",
    color: {
      argb: "#000"
    }
  },
  left: {
    style: "thin",
    color: {
      argb: "#000"
    }
  },
  bottom: {
    style: "thin",
    color: {
      argb: "#000"
    }
  },
  right: {
    style: "thin",
    color: {
      argb: "#000"
    }
  }
};
var row = 0;
var reportExpiredWarehouseExcel = exports.reportExpiredWarehouseExcel = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(_ref) {
    var data, fileName, workbook, worksheet, startTableRow, startTable, dataFilter, buffer, fileType, fileExtension, blob;
    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          data = _ref.data;
          // config export excel
          fileName = "Report expired warehouse";
          workbook = new Excel.Workbook();
          worksheet = workbook.addWorksheet("Report", {
            pageSetup: {
              fitToPage: true,
              fitToHeight: 5,
              fitToWidth: 7
            },
            views: [{
              state: 'frozen',
              ySplit: 2
            }]
          }); //add table
          startTableRow = 1;
          startTable = worksheet.getCell("A".concat(startTableRow++));
          startTable.style = {
            font: {
              color: {
                argb: "ffff0202"
              }
            }
          };
          dataFilter = data;
          generateTable(worksheet, dataFilter, startTableRow);
          _context.next = 11;
          return workbook.xlsx.writeBuffer();
        case 11:
          buffer = _context.sent;
          fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          fileExtension = ".xlsx";
          blob = new Blob([buffer], {
            type: fileType
          });
          (0, _fileSaver.saveAs)(blob, fileName + fileExtension);
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function reportExpiredWarehouseExcel(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var generateTable = function generateTable(worksheet, data, startTableRow) {
  //transform data
  var report = [];
  data.forEach(function (e) {
    var temp = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, e), {}, {
      rowspan: 0
    });
    report.push(temp);
  });
  var count = 0;
  report.forEach(function (element, index) {
    count++;
    if (index < report.length - 1 && element.productId != report[index + 1].productId) {
      report[index + 1 - count].rowspan = count;
      count = 0;
    }
  });
  if (report.length) {
    report[report.length - count].rowspan = count;
  }
  var startRow = startTableRow;
  var dataExcel = [{
    value: "Product",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "productName",
    width: 20,
    mergeRow: true
  }, {
    value: "Product SKU",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "productSKU",
    width: 20,
    mergeRow: true
  }, {
    value: "Lot No",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "lotNumber",
    width: 20
  }, {
    value: "Expired",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "expired",
    format: 'date',
    width: 15
  }, {
    value: "Manufacture date",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "dateOfManufacture",
    format: 'date',
    width: 15
  }, {
    value: "Total import",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "totalIn",
    numFmt: '#,##0',
    width: 12
  }, {
    value: "Total export",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "totalOut",
    numFmt: '#,##0',
    width: 12
  }];
  //render title
  var headerRow = worksheet.getRow(1);
  var dateString = '';
  headerRow.values = ["\u671F\u9650\u5207\u308C\u5728\u5EAB\u7BA1\u7406\u8868/ B\u1EA2NG QU\u1EA2N L\xDD T\u1ED2N KHO H\u1EBET H\u1EA0N"];
  headerRow.eachCell(function (item) {
    return item.style = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, fontBold), {}, {
      alignment: {
        horizontal: 'center'
      }
    });
  });
  worksheet.mergeCells(1, 1, 1, dataExcel.length);
  var char = "A";
  dataExcel.forEach(function (element) {
    var style = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, element.style), {}, {
      border: border,
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: {
          argb: 'ffff01'
        },
        bgColor: {
          argb: 'ffff01'
        }
      },
      alignment: {
        wrapText: true,
        vertical: 'middle'
      }
    });
    worksheet.getCell("".concat(char).concat(startRow)).style = style;
    worksheet.getCell("".concat(char).concat(startRow)).value = element.value;
    worksheet.getRow(startRow).height = 50;
    row = startRow + 1;
    report.forEach(function (order, index) {
      var rowIndex = startRow + index + 1;
      worksheet.getRow(rowIndex).height = 50;
      worksheet.getCell("".concat(char).concat(rowIndex)).style = {
        border: border,
        alignment: {
          wrapText: true,
          vertical: 'middle'
        }
      };
      element.numFmt && (worksheet.getCell("".concat(char).concat(rowIndex)).numFmt = element.numFmt);
      var value = (0, _index.generateProp)(order, element.prop, element.format);
      if (element.mergeRow && order.rowspan) {
        worksheet.mergeCells("".concat(char).concat(rowIndex, ":").concat(char).concat(rowIndex - 1 + order.rowspan));
      }
      worksheet.getCell("".concat(char).concat(rowIndex)).value = value;
      row = rowIndex;
    });
    char = (0, _string.nextChar)(char);
  });
  worksheet.columns.forEach(function (e, i) {
    if (dataExcel[i]) e.width = dataExcel[i].width;
  });
};